import { HeroExperimentImage } from './HeroExperiment'
import styles from '../Hero/Hero.module.scss'
import { useContext } from 'react'
import { GlobalProps } from 'src/utils/globalProps'
import { getAssetUrl } from 'src/utils/helpers/helpers'
import { useHeroImageVariant } from 'src/lib/optimizely/experiments/use-hero-image-variant'
import { ExtendedHeroImage } from '../Hero/Hero'

interface HeroImageExperimentContainerProps {
  isDesktop?: boolean
  heroContrainer?: React.ReactNode
  heroImages?: string[]
}

export const HeroImageExperimentContainer: React.FC<
  HeroImageExperimentContainerProps
> = ({ isDesktop, heroContrainer, heroImages }) => {
  const { country, brand, awazeClient } = useContext(GlobalProps)

  const BRANDS_WITH_VARIANT_IMAGES = [
    'cottages.com',
    'hoseasons',
    'jamesVillas',
  ]
  const COUNTRIES_WITH_VARIANT_IMAGES = ['DK', 'DE']

  const { isVariant, isLoaded: isLoadedHeroImage } = useHeroImageVariant()

  const hasVariantImage =
    BRANDS_WITH_VARIANT_IMAGES.includes(brand) ||
    (brand === 'novasol' && COUNTRIES_WITH_VARIANT_IMAGES.includes(country))

  const variantHeroImage = hasVariantImage
    ? getAssetUrl(`/images/${brand}-hero-image.png`)
    : null

  return (
    <>
      {isLoadedHeroImage &&
        (isVariant &&
        awazeClient !== 'guest-app' &&
        variantHeroImage &&
        isDesktop ? (
          <HeroExperimentImage
            backgroundImage={variantHeroImage}
            data-ga="hero-image"
            style={{
              minHeight: '0', // needed to override the default min-height
              // to make the hero image adapt to the height of the content
            }}
          >
            <div className={styles.heroExperiment}>{heroContrainer}</div>
          </HeroExperimentImage>
        ) : (
          <ExtendedHeroImage
            backgroundImages={heroImages}
            data-ga="hero-image"
            style={{
              minHeight: '0', // needed to override the default min-height
              // to make the hero image adapt to the height of the content
            }}
          >
            <div className={styles.hero}>{heroContrainer}</div>
          </ExtendedHeroImage>
        ))}
    </>
  )
}
